import React from "react";
import { Link } from "react-router-dom";

function Exercise({ exercise }) {
  return (
    <Link to={`/exercises/exercise/${exercise.id}`}>
      <div className="flex flex-col h-full items-center border-2 my-2 mx-2 py-2 rounded-lg shadow-lg">
        <div>
          <h2 className="font-bold uppercase text-green-500">
            {exercise.name}
          </h2>
        </div>
        <div>
          <img src={exercise.gifUrl} alt="Exercise" />
        </div>
        <div className="capitalize text-center">
          <p>
            <span className="font-bold capitalize">Equipment:</span>{" "}
            {exercise.equipment}
          </p>
          <p>
            <span className="font-bold capitalize">Muscle Group:</span>{" "}
            {exercise.target}
          </p>
        </div>
      </div>
    </Link>
  );
}

export default Exercise;
